import { useRef } from "react" 
import { TextureLoader, Uniform } from 'three'
import { useLoader, useFrame } from "@react-three/fiber"

import vertexShader from '../../shaders/tvnoise/vertex.glsl'
import fragmentShader from '../../shaders/tvnoise/fragment.glsl'

export default function TvScreen(props)
{

    const planeRef = useRef()
    const logosRef = useRef()

    const githubTexture = useLoader(TextureLoader, "./logos/logoGithub.png");
    const linkedinTexture = useLoader(TextureLoader, "./logos/logoLinkedin.png");
    const cvTexture = useLoader(TextureLoader, "./logos/logoCV.png");
   

      useFrame(({ clock }) => {

        planeRef.current.material.uniforms.uTime.value = clock.getElapsedTime();
       
        logosRef.current.children.forEach((child) => {
          if (child.material) {
            child.material.opacity = props.opacity;
          }
        })
      });

      const shaderMaterial = {
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        uniforms: {
          uTime: new Uniform(0),
          uProgress: new Uniform(props.progress)
        }
    
      }

    const handleClick = (url) => {
      if(props.opacity > 0.9)
      {
        window.open(url, "_blank");
      }
        
    };

    return<>

    <ambientLight intensity={1} />
    <mesh position={[0.61, 2.35, -3.49]} ref={ planeRef }>
        <planeGeometry args={[0.65, 0.45]} />
        <shaderMaterial 
          attach="material" 
          args={[shaderMaterial]}  
        />  
    </mesh>
    
    <group ref={logosRef}>
      <mesh 
        position={[0.42, 2.35, -3.48]} 
        scale={[0.12, 0.125, 0.125]} 
        onClick={() => handleClick("https://github.com/gopiO-O")}
      >
        <planeGeometry/>
        <meshBasicMaterial  map={githubTexture} transparent />
      </mesh>

      <mesh 
        position={[0.61, 2.35, -3.48]} 
        scale={[0.11, 0.125, 0.125]} 
        onClick={() => handleClick("https://www.linkedin.com/in/mistercalifornia/")}
      >
        <planeGeometry/>
        <meshBasicMaterial  map={linkedinTexture} transparent />
      </mesh>

      <mesh 
        position={[0.80, 2.35, -3.48]} 
        scale={[0.095, 0.125, 0.125]}
        onClick={() => handleClick("./CV/Gopi_Krishnan_Resume.pdf")}
      >
        <planeGeometry/>
        <meshBasicMaterial  map={cvTexture} transparent />
      </mesh>
    </group>
    
    </>

}